<template>
  <div class="loading-spinner-container" :class="containerClass">
    <div 
      class="animate-spin rounded-full border-t-transparent" 
      :class="[
        size === 'small' ? 'h-6 w-6 border-2' : 
        size === 'medium' ? 'h-10 w-10 border-3' : 
        'h-16 w-16 border-4',
        colorClass
      ]"
      role="status"
    ></div>
    <span v-if="message" class="loading-text mt-2 text-sm" :class="textColorClass">{{ message }}</span>
    <span v-else class="sr-only">Cargando...</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: 'medium', // 'small', 'medium', 'large'
    validator: (value) => ['small', 'medium', 'large'].includes(value)
  },
  color: {
    type: String,
    default: 'primary', // 'primary', 'secondary', 'white'
    validator: (value) => ['primary', 'secondary', 'white'].includes(value)
  },
  message: {
    type: String,
    default: ''
  },
  fullscreen: {
    type: Boolean,
    default: false
  },
  centered: {
    type: Boolean,
    default: true
  },
  overlay: {
    type: Boolean,
    default: false
  }
});

const colorClass = computed(() => {
  switch (props.color) {
    case 'primary': 
      return 'border-indigo-600 border-r-indigo-600/30 border-b-indigo-600/30 border-l-indigo-600/30';
    case 'secondary': 
      return 'border-gray-800 border-r-gray-800/30 border-b-gray-800/30 border-l-gray-800/30';
    case 'white': 
      return 'border-white border-r-white/30 border-b-white/30 border-l-white/30';
    default: 
      return 'border-indigo-600 border-r-indigo-600/30 border-b-indigo-600/30 border-l-indigo-600/30';
  }
});

const textColorClass = computed(() => {
  switch (props.color) {
    case 'primary': return 'text-indigo-600';
    case 'secondary': return 'text-gray-800';
    case 'white': return 'text-white';
    default: return 'text-indigo-600';
  }
});

const containerClass = computed(() => {
  const classes = [];
  
  // Fullscreen
  if (props.fullscreen) {
    classes.push('fixed inset-0 z-50 flex flex-col items-center justify-center');
    
    if (props.overlay) {
      classes.push('bg-black/50 backdrop-blur-sm');
    }
  } 
  // Centered in parent
  else if (props.centered) {
    classes.push('flex flex-col items-center justify-center py-6');
  }
  
  return classes.join(' ');
});
</script>

<style scoped>
.loading-spinner-container {
  transition: all 0.3s ease;
}

.border-3 {
  border-width: 3px;
}
</style> 